import type { ChipTone } from '@/components/common/StatusChip';
import type { StudentStatus } from '@/types/shared';

/** Chip tone per D1 8-value status list — 10-design-system.md §4.6. */
const TONE_BY_STATUS: Record<StudentStatus, ChipTone> = {
  ناجح: 'success',
  راسب: 'danger',
  منقول: 'info',
  'راسب سنتين': 'danger',
  خدمات: 'neutral',
  منازل: 'neutral',
  استثناء: 'warning',
  أزهر: 'info',
};

export function toneForStudentStatus(status: StudentStatus): ChipTone {
  return TONE_BY_STATUS[status] ?? 'neutral';
}
